import { render } from "./PlaceForm.vue?vue&type=template&id=1ae4324b&scoped=true"
import script from "./PlaceForm.vue?vue&type=script&lang=js"
export * from "./PlaceForm.vue?vue&type=script&lang=js"

import "./PlaceForm.vue?vue&type=style&index=0&id=1ae4324b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae4324b"]])

export default __exports__